// 不在左侧菜单中，但是在Main组件的子页面中显示的路由定义在这个文件中

import Main from '../../manager/manager_index.vue'

// 修改密码
// const updatePassword = {
//   name: 'updatePassword',
//   path: 'updatePassword',
//   title: '修改密码',
//   component: (resolve) => require(['../components/update_password.vue'], resolve)
// }

// 消息推送统计
const messageStats = {
  name: 'message-stats',
  path: 'message-stats',
  title: '消息推送统计',
  component: (resolve) => require(['../components/stats/message-stats/message-stats.vue'], resolve)
}

// 支付统计
const payStats = {
  name: 'PayStats',
  path: 'pay-stats',
  title: '支付统计',
  component: (resolve) => require(['../components/stats/pay-stats/pay-stats.vue'], resolve)
}

// 人脸识别统计
const faceStats = {
  name: 'FaceStats',
  path: 'face-stats',
  title: '人脸识别统计',
  component: (resolve) => require(['../components/stats/face-stats/face-stats.vue'], resolve)
}

// 发票服务统计
const invoiceStats = {
  name: 'InvoiceStats',
  path: 'invoice-stats',
  title: '发票服务统计',
  component: (resolve) => require(['../components/stats/invoice-stats/invoice-stats.vue'], resolve)
}

// 定义的路由需要添加到这个数组中
const childrenRouter = [
  messageStats,
  payStats,
  faceStats,
  invoiceStats
]

const customMainRouter = {
  path: '/',
  name: 'customMainRouter',
  redirect: '/home',
  component: Main,
  children: [
    ...childrenRouter
  ]
}

export default customMainRouter



// WEBPACK FOOTER //
// ./src/custom/router/custom-main-routers.js